import {EnvironmentStage} from "../data/EnvironmentStage";

export let Environment: {
	frontendHost: string;
	kiziBackendHost: string;
	surebaseBackendHost: string;
	riskBackendHost: string;
	cognitoClientId: string;
	stage: EnvironmentStage;
	kiziStage: string;
	debug?: boolean;
	kiziSubscriptionUrl?: string;
};
const stage = process.env.REACT_APP_STAGE?.toLowerCase();
switch (stage) {
	case "kizilocal":
		Environment = {
			frontendHost: "http://localhost:3000",
			kiziBackendHost: "https://api-dev.kizi.nl",
			surebaseBackendHost: "https://api-dev.surebase.nl",
			riskBackendHost: "https://graphql.dev.risk.services",
			cognitoClientId: "6vtccjj2sa7jpb668sa0itugjt",
			stage: "dev",
			kiziStage: "kizidev",
			debug: true,
			kiziSubscriptionUrl: "wss://afkqh8qj4e.execute-api.eu-west-1.amazonaws.com/kizidev"
		};
		break;
	case "kizidev":
		Environment = {
			frontendHost: "https://portal-dev.kizi.nl",
			kiziBackendHost: "https://api-dev.kizi.nl",
			surebaseBackendHost: "https://api-dev.surebase.nl",
			riskBackendHost: "https://graphql.dev.risk.services",
			cognitoClientId: "6vtccjj2sa7jpb668sa0itugjt",
			stage: "dev",
			kiziStage: "kizidev",
			kiziSubscriptionUrl: "wss://afkqh8qj4e.execute-api.eu-west-1.amazonaws.com/kizidev"
		};
		break;
	case "kiziacc":
		Environment = {
			frontendHost: "https://portal-acc.kizi.nl",
			kiziBackendHost: "https://api-acc-ext.kizi.nl",
			surebaseBackendHost: "https://api-acc.surebase.nl",
			riskBackendHost: "https://graphql.acc.risk.nl",
			cognitoClientId: "2mmt16sp1ti5mn2elhq5423p5k",
			stage: "acc",
			kiziStage: "kiziacc",
			kiziSubscriptionUrl: "wss://x5e5qna9c9.execute-api.eu-west-1.amazonaws.com/kiziacc/"
		};
		break;
	case "kiziprod":
		Environment = {
			frontendHost: "https://portal.kizi.nl",
			kiziBackendHost: "https://api.kizi.nl",
			surebaseBackendHost: "https://api.surebase.nl",
			riskBackendHost: "https://graphql.risk.nl",
			cognitoClientId: "7vaq4im6t7b5k6r6vti7vdvntc",
			stage: "prod",
			kiziStage: "kiziprod",
			kiziSubscriptionUrl: "wss://qbk1581n3g.execute-api.eu-west-1.amazonaws.com/kiziprod/"
		};
		break;
	// Local development against the PRODUCTION backends. Same hosts, Cognito
	// client and stage as kiziprod, but served from localhost so it can be run
	// with `npm run start:kiziprod`. Requires http://localhost:3000/login and
	// /logout to be whitelisted as callback URLs on the prod Cognito app client.
	// WARNING: this talks to real production data.
	case "kiziprodlocal":
		Environment = {
			frontendHost: "http://localhost:3000",
			kiziBackendHost: "https://api.kizi.nl",
			surebaseBackendHost: "https://api.surebase.nl",
			riskBackendHost: "https://graphql.risk.nl",
			cognitoClientId: "7vaq4im6t7b5k6r6vti7vdvntc",
			stage: "prod",
			kiziStage: "kiziprod",
			debug: true,
			kiziSubscriptionUrl: "wss://qbk1581n3g.execute-api.eu-west-1.amazonaws.com/kiziprod/"
		};
		break;
	default:
		throw new Error("Cannot identify runtime stage.");
}
